import React from 'react';
import { PiFlagPennantFill } from "react-icons/pi";
import { FaHandshakeSimple } from "react-icons/fa6";
import { IoPeopleSharp } from "react-icons/io5";
import './PromiseSection.css';

const PromiseSection = () => {
  return (
    <section className="promise-section">
      <div className="promise-container">
        
        {/* Card 1: Our Promise */}
        <div className="promise-card">
          <div className="card-icon">
            <FaHandshakeSimple />
          </div>
          <h3 className="card-title">Our Promise</h3>
          <ul className="promise-list">
            <li>100% Natural Ingredients</li>
            <li>No Chemicals or Additives</li>
            <li>Farm-Sourced, Sustainably Made</li>
            <li>Consistent Quality for Retail & Bulk Supply</li>
          </ul>
        </div>

        {/* Card 2: Who We Serve */}
        <div className="promise-card">
          <div className="card-icon">
            <IoPeopleSharp />
          </div>
          <h3 className="card-title">Who We Serve</h3>
          <p>
            Biofana serves both individual consumers and businesses — including food manufacturers,
            wellness brands, exporters, and cosmetic formulators — who want reliable, high-quality
            powdered ingredients they can trust.
          </p>
        </div>

        {/* Card 3: Mission */}
        <div className="promise-card">
          <div className="card-icon">
            <PiFlagPennantFill />
          </div>
          <h3 className="card-title">Mission</h3>
          <p>
            To provide safe, sustainable, and functional food powders that promote health
            and innovation in every scoop.
          </p>
        </div>

      </div>
    </section>
  );
};

export default PromiseSection;